// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './../store/store'

//Vue.use(Vuex)

// 引入ELEMENT
import ElementUI from 'element-ui'
Vue.use(ElementUI)

import 'element-ui/lib/theme-chalk/index.css'

// 引入公共样式库
import '../static/common.css'
import '../static/iconfont/iconfont.css'

// 引入FILTER
import filters from '../src/utils/filter'
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})


import router from './router'
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = '安徽无线技术电协会-' + to.meta.title
  }
  next()
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js